// @flow

export type AudioAssets = {
  wrong: string,
  right: string,
  help: string,
  harder: string,
  again: string,
  done: string,
}

export type PieceData = {
  width: number,
  height: number,
  pieceX: number,
  pieceY: number,
  glowOffset: number,
  overlay: string,
  image: string,
  path: string,
  number: number,
  finished?: boolean,
};

export type PiecesData = Array<PieceData>;

export type FinishedPieces = Array<number>;

export type Block = {
  width: number,
  height: number,
  x: number,
  y: number,
  path: string,
  overlay: string,
  glow: string,
};

export type Level = {
  levelImage: string,
  helpImage: string,
  blocks: Array<Block>,
};

export type Levels = Array<Level>;

export type PlacePuzzlePiece = (
  placeNumber: number,
  droppedPieceNumber: number,
) => void;

// item types for drag & drop
const DnDTypes = {
  DRAGGABLE_PIECE: 'draggablePiece',
  DROPPABLE_PIECE: 'droppablePiece',
};

export default DnDTypes;
